import AuthFormEdf from "/src/features/auth/components/AuthFormEdf/AuthFormEdf";
import QuotePart from '/src/components/quote/QuotePart';
import "./loginPageEdf.css";

function loginPageEdf() {
    return(
        <div className="page default edf-login-page">
            <AuthFormEdf></AuthFormEdf>
            <div className="quote-part">
                <QuotePart fontSize="50" fontColor="white" />
            </div>
        </div>
    )
}

export default loginPageEdf
